import { PageNotice } from '../../../shared/components/PageFeedback';
import React from 'react';
import { Link } from 'react-router-dom';
import {
  Users,
  UserCheck,
  UserPlus,
  Trophy,
} from '../../../shared/assets/AppIcons';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/shared/ui/card';
import { Badge } from '@/shared/ui/badge';
import { getRoutePath, ROUTE_IDS } from '@/app/router/route-registry';
import { formatCurrency } from '@/modules/dashboard/utils/dashboard.helpers';
import '@/modules/dashboard/styles/ClientsOverviewSection.css';

function getClientResolutionHint(status) {
  if (status === 'legacy_fallback') {
    return 'Cliente da snapshot legacy';
  }

  if (status === 'missing_client_id') {
    return 'ClientId mancante';
  }

  if (status === 'unresolved_client_reference') {
    return 'ClientId non risolto nel catalogo clienti';
  }

  return '';
}

export default function ClientsOverviewSection({ clientsSummary }) {
  const clientsPath = getRoutePath(ROUTE_IDS.CLIENTS);

  return (
    <Card className="clients-overview">
      <CardHeader>
        <div className="clients-overview__header">
          <div>
            <CardTitle className="clients-overview__title">
              <Users className="clients-overview__title-icon" size={16} />
              Clienti
            </CardTitle>
            <CardDescription className="clients-overview__description">
              Panoramica clienti e top performer
            </CardDescription>
          </div>

          <Link to={clientsPath}>
            <Badge variant="outline" className="clients-overview__link-badge">
              Vedi tutti
            </Badge>
          </Link>
        </div>
      </CardHeader>

      <CardContent>
        <div className="clients-overview__stats">
          <div className="clients-overview__stat-card clients-overview__stat-card--neutral">
            <div className="clients-overview__stat-left">
              <div className="clients-overview__stat-icon-wrap clients-overview__stat-icon-wrap--neutral">
                <Users size={16} className="clients-overview__stat-icon clients-overview__stat-icon--neutral" />
              </div>
              <span className="clients-overview__stat-label clients-overview__stat-label--neutral">
                Totale Clienti
              </span>
            </div>

            <p className="clients-overview__stat-value clients-overview__stat-value--neutral">
              {clientsSummary.totalClients}
            </p>
          </div>

          <div className="clients-overview__stat-card clients-overview__stat-card--success">
            <div className="clients-overview__stat-left">
              <div className="clients-overview__stat-icon-wrap clients-overview__stat-icon-wrap--success">
                <UserCheck size={16} className="clients-overview__stat-icon clients-overview__stat-icon--success" />
              </div>
              <div>
                <span className="clients-overview__stat-label clients-overview__stat-label--success">
                  Clienti Attivi
                </span>
                <p className="clients-overview__stat-subtext clients-overview__stat-subtext--success">
                  Con pratiche in corso
                </p>
              </div>
            </div>

            <p className="clients-overview__stat-value clients-overview__stat-value--success">
              {clientsSummary.activeClients}
            </p>
          </div>

          <div className="clients-overview__stat-card clients-overview__stat-card--warning">
            <div className="clients-overview__stat-left">
              <div className="clients-overview__stat-icon-wrap clients-overview__stat-icon-wrap--warning">
                <UserPlus size={16} className="clients-overview__stat-icon clients-overview__stat-icon--warning" />
              </div>
              <div>
                <span className="clients-overview__stat-label clients-overview__stat-label--warning">
                  Potenziali
                </span>
                <p className="clients-overview__stat-subtext clients-overview__stat-subtext--warning">
                  Solo in proposte
                </p>
              </div>
            </div>

            <p className="clients-overview__stat-value clients-overview__stat-value--warning">
              {clientsSummary.potentialClients}
            </p>
          </div>
        </div>

        <div className="clients-overview__top">
          <h4 className="clients-overview__top-title">
            <Trophy size={16} className="clients-overview__top-title-icon" />
            Clienti Principali
          </h4>

          <div className="clients-overview__top-list">
            {clientsSummary.topClients.map((item, index) => (
              <div
                key={`${item.client}-${index}`}
                className="clients-overview__top-item"
              >
                <span className="clients-overview__top-name">
                  {item.clientResolvedName || item.client}
                  {getClientResolutionHint(item.clientResolutionStatus) ? (
                    <span className="block text-[11px] text-[var(--warning-text)]">
                      {getClientResolutionHint(item.clientResolutionStatus)}
                    </span>
                  ) : null}
                </span>
                <span className="clients-overview__top-value">
                  {formatCurrency(item.value)}
                </span>
              </div>
            ))}
          </div>
          {clientsSummary.unresolvedClientReferencesCount > 0 ? (
            <PageNotice role="alert" className="mt-3 text-xs wt-inline-error">
              {clientsSummary.unresolvedClientReferencesCount} riferimenti cliente non risolti
            </PageNotice>
          ) : null}
        </div>
      </CardContent>
    </Card>
  );
}
